import BaseService from './base.service'

class ModelCarService extends BaseService {
    getList() {
        return new Promise((resolve, reject) => {
            return this.request().post({
                method: 'ModelCar.getList',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }
}

export default new ModelCarService()
